import React from 'react';
import MUiTextField from '@material-ui/core/TextField';

const TextField = (props) => {
  return (
    <MUiTextField 
      InputLabelProps = {{ style: { fontSize: '0.8rem' } }}
      inputProps={{ style: { fontSize: '0.9rem' } }}
    {...props} />
  )
}

export default TextField